import dayjs from 'dayjs';
import { UiTitle, UiText } from 'znanie-uikit';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import ImageProxy from 'components/common/ImageProxy';
import { Link } from 'components/common/Link';

import { PostType } from 'graphql/types';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import css from './PostCard.module.scss';

interface IProps {
  post: PostType;
  index: number;
}

export default function PostCard({ post, index }: IProps) {
  const { isMobile } = useMediaQueries();

  const handlePostCardClick = (post: PostType) => {
    const { slug, publishedAt } = post;

    trackAnalyticsData(AnalyticsEvent.NEWS_ITEM_CLICK, {
      slug,
      publishedAt,
      order: index,
    });
  };

  return (
    <div className={css.block}>
      {(post.imageUrl || post.mobileImageUrl) && (
        <Link
          href={`/news/${post.slug}`}
          onClick={() => {
            handlePostCardClick(post);
          }}
        >
          <div className={css.cover}>
            <ImageProxy
              src={
                (isMobile && post.mobileImageUrl
                  ? post.mobileImageUrl
                  : post.imageUrl) || ''
              }
              alt={`Изображение новости: ${post.title}`}
              objectFit="cover"
              objectPosition="center"
              placeholder="blur"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM8Uw8AAh0BTZud3BwAAAAASUVORK5CYII="
              layout="fill"
              sourceWidth={isMobile ? 450 : 620}
              sourceHeight={isMobile ? 240 : 400}
              resizingType="fill"
              gravityType="ce"
            />
          </div>
        </Link>
      )}
      <div className={css.info}>
        <UiText size="small_x" color="grey" weight="normal">
          {dayjs(post.publishedAt).format('DD MMMM YYYY')}
        </UiText>
        <Link href={`/news/${post.slug}`}>
          <UiTitle className={css.title} as="h2">
            {post.title}
          </UiTitle>
        </Link>
        <UiText className={css.text} size="normal">
          <UiText.Wrapper disableMore>{post.description || ''}</UiText.Wrapper>
        </UiText>
      </div>
    </div>
  );
}
